import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const CreateObjectValidationSchema = () => {
  const { t } = useTranslation()

  return Yup.object().shape({
    name: Yup.string().required(t('objectsPage.errors.name')),
    address: Yup.string(),
    category: Yup.string().required(t('objectsPage.errors.category')),
  })
}
